import { getIcon } from "../utils/icons.js";

class SonikitAlert extends HTMLElement {
  #shadow

  constructor() {
    super();
    this.#shadow = this.attachShadow({ mode: 'closed' });

    const template = document.createElement('template');
    template.innerHTML = `
      <style>
        .wrapper {
          position: fixed;
          top: 15px;
          left: 0;
          right: 0;
          margin: auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 15px;
          min-width: 200px;
          max-width: 300px;
          padding: 15px;
          box-sizing: border-box;
          background-color: rgba(0,0,0,0.7);
          backdrop-filter: blur(10px);
          color: white;
          border-radius: 10px;
          z-index: 9999;
          text-align: center;
          font-family: Arial, Helvetica, sans-serif;
          user-select: none;
        }
        
        .message {
          display: flex;
          justify-content: flex-start;
          gap: 10px;
          text-align: center;
          pointer-events: none;
        }
        .close {
          cursor: pointer;
          background: transparent;
          padding: 0;
          margin: 0;
          font-size: 1em;
          border: none;
          outline: none;
        }
        .close svg{
          width: 24px;
          height: 24px;
          fill: white;
        }
      </style>
      <div class="wrapper">
        <div class="message"></div>
        <button type="button" class="close">${getIcon('close')}</button>
      </div>
    `

    this.#shadow.appendChild(template.content.cloneNode(true));
    this._contentEl = this.#shadow.querySelector('.message');
    
    const closeButton = this.#shadow.querySelector('.close');
    closeButton.addEventListener('click', () => this.remove());
  }

  setContent(html) {
    if (this._contentEl) {
      if (html instanceof Node) {
        this._contentEl.appendChild(html);
      } else {
        this._contentEl.innerHTML = html;
      }
    }
  }
}

customElements.define('sonikit-alert', SonikitAlert);